var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowDownSprite = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 101,
  height: 39,
  y: 60,
  viewBox: "-10 -10 101 39"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFD25D",
  fillRule: "evenodd",
  stroke: "#F2F2F2",
  strokeWidth: 2,
  d: "M40.616 12 3.294 2 2 6.83l38.59 10.34.004.012.022-.005.021.005.003-.012L79.231 6.83 77.937 2z"
})));
export default SvgArrowDownSprite;